import { Button, ButtonProps } from '@bw/foundry';
import { useFormikContext } from 'formik';
import React from 'react';

export type FormikSubmitButtonProps = ButtonProps & {
  allowWhenPristine?: boolean;
};

/**
 * Submit button that automatically hooks into formik's
 * loading and validation state
 */
const FormikSubmitButton = ({
  allowWhenPristine,
  ...props
}: FormikSubmitButtonProps) => {
  const { isValid, dirty, isSubmitting } = useFormikContext();
  return (
    <Button
      type="submit"
      disabled={!isValid || (!dirty && !allowWhenPristine)}
      loading={isSubmitting}
      {...props}
    />
  );
};

export default FormikSubmitButton;
